/* eslint-disable camelcase */

/**
 * The data of a logged-in customer.
 * @type {jQuery}
 */
const $chatData = document.querySelector("#salesforce-chat");
/** Whether or not the person using the webchat is a logged-in customer. */
const isCustomer = $chatData !== null;

const customerFirstName = $chatData?.dataset.customerName;
const customerLastname = $chatData?.dataset.customerLastname;
const customerEmail = $chatData?.dataset.customerEmail;

/**
 * This function is used by SalesForce to initialize the embedded service
 * window. The`embedded_svc` and `initESW` function are built-in SF functions
 * and should be modified according to the documentation.
 *
 * @see https://developer.salesforce.com/docs/atlas.en-us.snapins_web_dev.meta/snapins_web_dev/snapins_web_overview.htm
 * @see https://help.salesforce.com/s/articleView?id=sf.snapins_chat_parameters.htm&type=5
 * @param {string} gslbBaseURL The GSLB base URL.
 */
const initESW = (gslbBaseURL) => {
  embedded_svc.settings.displayHelpButton = true;
  embedded_svc.settings.language = isCustomer ? "en-US" : "";

  embedded_svc.settings.disabledMinimizedText = 'Offline'; //(Defaults to Agent Offline)
  embedded_svc.settings.storageDomain = 'golo.com'; //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)

  embedded_svc.settings.offlineSupportMinimizedText = 'Offline'; //(Defaults to Contact Us)

  if (isCustomer) {
    // customer details obtained from Shopify
    embedded_svc.settings.extraPrechatFormDetails = [
      {
        label: "First Name",
        name: "FirstName",
        value: customerFirstName,
        displayToAgent: true,
      },
      {
        label: "Last Name",
        value: customerLastname,
        displayToAgent: true,
      },
      {
        label: "Email",
        value: customerEmail,
        displayToAgent: true,
      },
      {
        label: "Subject",
        value: "Web chat",
        displayToAgent: true,
      },
      {
        label: "Origin",
        value: "Web",
        displayToAgent: true,
      },
    ];
  }

  embedded_svc.settings.enabledFeatures = ["LiveAgent"];
  embedded_svc.settings.entryFeature = "LiveAgent";

  embedded_svc.init(
    "https://golollc.my.salesforce.com",
    "https://golollc.my.salesforce-sites.com/liveAgentSetupFlow",
    gslbBaseURL,
    "00D6g000000tTSY",
    "Customer_Support_Queue",
    {
      baseLiveAgentContentURL: "https://c.la11-core1.sfdc-yfeipo.salesforceliveagent.com/content",
      deploymentId: "5726g0000008oyi",
      buttonId: "5734V0000010yio",
      baseLiveAgentURL: "https://d.la11-core1.sfdc-yfeipo.salesforceliveagent.com/chat",
      eswLiveAgentDevName: "Customer_Support_Queue",
      isOfflineSupportEnabled: false,
    }
  );
};

// load the salesforce chat window script if not already loaded
if (!window.embedded_svc) {
  const s = document.createElement("script");
  s.setAttribute(
    "src",
    "https://golollc.my.salesforce.com/embeddedservice/5.0/esw.min.js"
  );
  s.onload = () => {
    initESW(null);
  };
  document.body.appendChild(s);

  // otherwise run the webchat script
} else {
  initESW("https://service.force.com");
}
